export default __webpack_public_path__ + "static/1165-b7294ece5f35e6d4be2e1273ffc5bac1.gif";